export default {
    parent: 'FeedbackLayout',
    url: '/feedback',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/feedback/index.js